// extracted by mini-css-extract-plugin
export var attachmentContainer = "_o3-0";
export var fileList = "_o3-2";
export var removeFileButton = "_o3-1";